// @flow

//
// a wrapper around window["BlueflagAuth"]
// so we dont get references to window throught the codebase
//

type BlueflagAuth = {
    forgotPasswordConfirm: (username: string, password: string, confirmationCode: string) => Promise<any>,
    forgotPasswordRequest: (username: string) => Promise<any>,
    signIn: (username: string, password: string) => Promise<any>,
    signInAuthCode: () => Promise<any>,
    signUpConfirm: (username: string) => Promise<any>,
    signUpConfirmResend: (username: string) => Promise<any>
};

const func = (): BlueflagAuth => window["BlueflagAuth"];

export default func;
